import { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { DevRoleSwitchModal } from "@/components/DevRoleSwitchModal";
import { useCurrentUser, userIsRealAppAdmin } from "@/lib/auth";
import { fetchDevRoleSwitchState } from "@/lib/devRoleSwitch";

/** Header-Button öffnet das Fenster zur Gruppensimulation (Admins, wenn die API aktiv ist). */
export function DevRoleSwitcher() {
  const { user } = useCurrentUser();
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(false);

  const canProbe =
    !!user && (userIsRealAppAdmin(user) || !!user.dev_role_switch || !!user.dev_switcher);

  const refreshMeta = useCallback(async () => {
    if (!canProbe) {
      setVisible(false);
      setActive(false);
      return;
    }
    const result = await fetchDevRoleSwitchState();
    setVisible(result.ok);
    setActive(result.ok ? result.state.active : false);
  }, [canProbe]);

  useEffect(() => {
    void refreshMeta();
  }, [refreshMeta]);

  if (!visible) return null;

  return (
    <>
      <button
        type="button"
        className={clsx(
          "inline-flex rounded-full border px-2.5 py-1 text-xs font-bold transition",
          active
            ? "border-amber-600 bg-amber-600 text-white hover:bg-amber-700"
            : "border-amber-500/50 bg-amber-500/15 text-label hover:bg-amber-500/25",
        )}
        onClick={() => setOpen(true)}
        title={
          active ? "Gruppensimulation aktiv – zum Bearbeiten öffnen" : "Rolle simulieren"
        }
      >
        Dev-Rolle
      </button>

      <DevRoleSwitchModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
